import {SxProps} from '@mui/material';

export const STYLES = {
  settings: {
    pb: '12px',
    pl: '26px',
    borderBottom: '1px solid #0D99FF',
  },
  title: {
    height: '22px',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '21px',
    color: '#3AC977',
  },
  button: {
    width: '21.35px',
    height: '22px',
    minWidth: 'unset',
  },
} as const satisfies SxProps;
